export default "__VITE_PUBLIC_ASSET__90f2d6ae__"